import { initializeApp } from 'firebase/app';

import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";
 
//Produccion
// const firebaseConfigDev = {
//   apiKey: "AIzaSyClRNqRuMhPThQcET93_u-n93XwO_aamtY",
//   authDomain: "confipetrol-dev.firebaseapp.com",
//   projectId: "confipetrol-dev",
//   storageBucket: "confipetrol-dev.appspot.com",
//   messagingSenderId: "25185134968",
//   appId: "1:25185134968:web:1eb2e679a0f9755e64808d",
//   measurementId: "G-3CSQD5NXJ4"
// };

//Database and Functions
const firebaseConfig = {
  apiKey: "AIzaSyC2TfBY_nec9V970Y_2uAZdaxGqkbL7b40",
  authDomain: "confipetrol-f7147.firebaseapp.com",
  projectId: "confipetrol-f7147",
  storageBucket: "confipetrol-f7147.appspot.com",
  messagingSenderId: "395538267968",
  appId: "1:395538267968:web:d364021eda8a4d0b6f04a5",
  measurementId: "G-7JZ8NGYJHJ"
};

const app = initializeApp(firebaseConfig);
// const app = initializeApp(firebaseConfigDev);

export const firebaseStorage = getStorage(app);
export const firebaseFunctions = getFunctions(app);
export const functionsHttpsCallable = (func) => httpsCallable(firebaseFunctions, func);
